import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-product-grid",
  templateUrl: "./med-icon-product-grid.component.html",
})
export class MedIconProductGridComponent extends SvgMixinComponent {}
